export interface DictParams {
  dictLabel?: string; // 字典标签
  dictValue?: string; // 字典键值
  dictSort?: string; // 显示排序
  dictType?: string; // 字典类型
  dictCodeType?: string; // 字典编码
  listClass?: string; // 回显样式
  cssClass?: string; // 样式属性
  status?: string; // 字典状态
  remark?: string; // 备注
}

export interface paramsType {
  dictSort?: string; // 字典排序
  dictLabel?: string; // 字典标签
  dictValue?: string; // 字典键值
  dictType?: string; // 字典类型
  cssClass?: string; // 样式属性（其他样式扩展）
  listClass?: string; // 表格字典样式
  isDefault?: string; // 是否默认（Y是 N否）
  status?: string; // 状态（0正常 1停用）
  dictCodeType?: string; // 字典编码类型
  remark?: string; // 备注
  dictCode?: string;
}
export function getSysDict() {
  return request({
    url: '/system/dict/type/getNewVDictInfo',
    method: 'get',
  });
}

// 查询字典类型列表
export function listType(query: any) {
  return request({
    url: '/system/dict/type/list',
    method: 'get',
    params: query,
  });
}
// 新增字典类型
export function addType(data: any) {
  return request({
    url: '/system/dict/type',
    method: 'post',
    data: data,
  });
}

// 查询字典类型详细
export function getType(dictId: any) {
  return request({
    url: '/system/dict/type/' + dictId,
    method: 'get',
  });
}

// 查询字典数据列表
export function listData(query: any) {
  return request({
    url: '/system/dict/data/list',
    method: 'get',
    params: query,
  });
}

// 新增字典数据
export function addData(data: any) {
  return request({
    url: '/system/dict/data',
    method: 'post',
    data: data,
  });
}

// 修改字典数据
export function updateData(data: any) {
  return request({
    url: '/system/dict/data',
    method: 'put',
    data: data,
  });
}

// 删除字典数据
export function delData(dictCode: any) {
  return request({
    url: '/system/dict/data/' + dictCode,
    method: 'delete',
  });
}

// 查询字典数据详细
export function getData(dictCode: any) {
  return request({
    url: '/system/dict/data/' + dictCode,
    method: 'get',
  });
}

// 修改字典
export function updateType(data: any) {
  return request({
    url: '/system/dict/type',
    method: 'put',
    data: data,
  });
}

// 删除字典
export function deleteDictById(dictIds: any) {
  return request({
    url: '/system/dict/type/' + dictIds,
    method: 'delete',
  });
}
